import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import NotificationTemplatesTable from '../../components/notificationTemplates/NotificationTemplatesTable';

const NotificationTemplates = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <NotificationTemplatesTable />
    </WrapperSection>
);

export default NotificationTemplates;
